import React from "react";
import { Link } from "react-router-dom";

const OurMisson: React.FC = () => {
  return (
    <div className="w-full">
      <div className="flex flex-col items-center lg:flex-row gap-10 justify-between w-full">
        <div>
          <h3 className="text-xl font-medium sm:text-2xl md:text-3xl lg:text-4xl xl:text-[3.6rem]">
            Our mission
          </h3>
          <p className="max-w-2xl font-medium text-sm pt-2 lg:pt-4 xl:pt-6 lg:text-xl">
            At Dream Weavers, our mission is to empower individuals and
            organizations through innovative learning solutions, skill
            development programs, and transformative training initiatives. We
            are committed to creating a positive impact across industries by
            fostering growth, excellence, and lifelong learning. Through
            technology-driven education, collaborative partnerships, and a
            passion for shaping the future, we aim to bridge skill gaps, enhance
            careers, and contribute to a more skilled and knowledgeable world.
          </p>
        </div>
        <div className="lg:mr-20">
          <div className="">
            <iframe
              title="YouTube video player"
              src="https://www.youtube.com/embed/ijLOuLiJzgY?si=aclijM9ktDpARloX"
              className="md:max-w-2xl w-96 h-[12rem] sm:h-[19rem] rounded-2xl xl:max-w-[30rem] max-h-[17rem] max-w-[17rem] xl:h-[17rem] xl:w-[30rem] lg:h-[20rem] sm:w-[29rem]"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              referrerPolicy="strict-origin-when-cross-origin"
              allowFullScreen
            ></iframe>
            <div className="mt-3">
              <Link to="/careers" className="pt-10">
                <button className="w-fit px-4 py-2 text-xs lg:text-base xl:text-[1.3rem] lg:px-6 xl:px-6 lg:py-2 sm:text-sm bg-[#00BB68] hover:bg-opacity-90 transition-all duration-200 ease-out text-white rounded-full">
                  Explore what it's like to work with us
                </button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OurMisson;
